<template>
    <div>
        <models-base-form
            :creating="creating"
            :newObject="newObject"
            :editObject="ponderacion"
            :service="service"
            @created="onCreated($event)"
            @updated="onUpdated($event)"
            v-if="ponderables"
        >
            <template v-slot:form="{ object }">
                <v-select
                    v-model="object.ponderableId"
                    :items="ponderables"
                    item-text="ponderable"
                    item-value="id"
                    label="Ponderable"
                ></v-select>
                <v-text-field v-model="object.ponderacion" label="Valor"></v-text-field>
            </template>
        </models-base-form>
    </div>
</template>

<script>
import { PonderablesService, PonderacionesService } from "../../../services/carreras-api.service"
export default {
    data() {
        return {
            ponderables: [],
            service: PonderacionesService,
            newObject: {
                ponderableId: null,
                ponderacion: "",
                carreraSedeId: this.carreraSedeId
            }
        }
    },
    props: ["carreraSedeId", "creating", "ponderacion"],
    methods: {
        onCreated(ponderacion) {
            this.$emit("created", ponderacion)
        },
        onUpdated(ponderacion) {
            this.$emit("updated", ponderacion)
        }
    },
    created() {
        PonderablesService.where().then(list => (this.ponderables = list))
    }
}
</script>
